import { Localized } from "@fluent/react";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks"
import { DocumentDescriptionField, updateDescriptionField } from "../documentsApi";
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";

const Label = ({ fieldName }: { fieldName: "description" | "area" | "purpose" | "title" | "language" }) => {
    switch (fieldName) {
        case "description": return <Localized id=''>Opis</Localized>
        case "area": return <Localized id=''>Obszar</Localized>
        case "purpose": return <Localized id=''>Cel</Localized>
        case "title": return <Localized id=''>Tytuł</Localized>
        case "language": return <Localized id=''>Język</Localized>
    }
}

export interface EditDescriptionFieldProps {
    documentId: AppId
    fieldName: DocumentDescriptionField
    value: string
    onSuccess: (fieldName: DocumentDescriptionField, newValue: string) => void
    onCancel: () => void
}

export const EditDescriptionField = (props: EditDescriptionFieldProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [value, setValue] = useState(props.value)

    const handleOkClick = () => {
        setSaving(true)
        dispatch(updateDescriptionField({
            documentId: props.documentId,
            fieldName: props.fieldName,
            value
        }))
            .then(unwrapResult)
            .then(() => { props.onSuccess(props.fieldName, value) })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setSaving(false)
            })
    }

    return <Dialog open={true} fullWidth maxWidth='md'>
        <DialogTitle
            sx={{
                bgcolor: (theme) => theme.palette.grey[200],
                borderBottom: "1px solid",
                borderColor: "divider",
                py: 0.75,
            }}>
            <Localized id='edit'>Edycja</Localized>
        </DialogTitle>
        <DialogContent>
            <TextField
                label={<Label fieldName={props.fieldName} />}
                value={value}
                multiline
                fullWidth
                minRows={props.fieldName === "title" ? 1 : 3}
                onChange={(event) => setValue(event.target.value)}
                sx={{ mt: 1 }}
            />
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleOkClick} />
            <CloseButton loading={saving} onClick={props.onCancel} />
        </DialogActions>
    </Dialog>
}
